import Vue from "vue"
import Vuex from "vuex"
import monitor from './modules/monitor';
Vue.use(Vuex);

//appInfo {ClientId, PlatfromId_VersionNumber_ChannelId, RequestDigestKey, RequestEncryptKey, ResponseDigestKey, ResponseEncryptKey}
const state = {
    token: sessionStorage.getItem('token') || null,
    AppInfo:{},
    UserInfo: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {},
    UserType: 0,
    AkipWay:'',
    links:[]
}
const mutations = {
    setToken:(state,token)=>{
        state.token = token;
        sessionStorage.setItem('token',token);
    },
    setAppInfo:(state,info)=>{
        if(info.RequestNowVersion){
            let vStr = info.RequestNowVersion,
            v = vStr.split('_')[1];
            Vue.prototype.$appVersion = v;
        }
        state.AppInfo = info;
    },
    setUserInfo:(state,info = {})=>{
        let UserInfo = state.UserInfo;
        for(let key in info){
            UserInfo[key] = info[key];
        }
        state.UserInfo = UserInfo;
        sessionStorage.setItem('userInfo',JSON.stringify(UserInfo));
    },
    setUserType: (state,info=0)=>{
        state.UserType = info;
    },
    setAkipWay:(state,val)=>{
        state.AkipWay = val;
    },
    setLinks:(state,arr)=>{
        state.links = arr;
    }
}
const getters = {
    UserType: state=>{
        return state.UserType;
    }
}
const modules = {
    monitor
}
export default new Vuex.Store({
    state,
    mutations,
    getters,
    modules
});